/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const updateMenuNameWithoutUpdatedAt = /* GraphQL */ `mutation UpdateMenuNameWithoutUpdatedAt(
  $input: UpdateMenuNameInput!
  $condition: ModelMenuNameConditionInput
) {
  updateMenuNameWithoutUpdatedAt(input: $input, condition: $condition) {
    language
    name
    menuId
    schemaId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMenuNameWithoutUpdatedAtMutationVariables,
  APITypes.UpdateMenuNameWithoutUpdatedAtMutation
>;
export const updateMenuDescriptionWithoutUpdatedAt = /* GraphQL */ `mutation UpdateMenuDescriptionWithoutUpdatedAt(
  $input: UpdateMenuDescriptionInput!
  $condition: ModelMenuDescriptionConditionInput
) {
  updateMenuDescriptionWithoutUpdatedAt(input: $input, condition: $condition) {
    language
    description
    menuId
    schemaId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMenuDescriptionWithoutUpdatedAtMutationVariables,
  APITypes.UpdateMenuDescriptionWithoutUpdatedAtMutation
>;
export const updateCountTableWithIncrement = /* GraphQL */ `mutation UpdateCountTableWithIncrement(
  $input: UpdateCountTableInput!
  $condition: ModelCountTableConditionInput
) {
  updateCountTableWithIncrement(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    tableName
    totalCount
    isUnRead
    isExpired
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCountTableWithIncrementMutationVariables,
  APITypes.UpdateCountTableWithIncrementMutation
>;
export const createEvent = /* GraphQL */ `mutation CreateEvent(
  $input: CreateEventInput!
  $condition: ModelEventConditionInput
) {
  createEvent(input: $input, condition: $condition) {
    html
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEventMutationVariables,
  APITypes.CreateEventMutation
>;
export const updateEvent = /* GraphQL */ `mutation UpdateEvent(
  $input: UpdateEventInput!
  $condition: ModelEventConditionInput
) {
  updateEvent(input: $input, condition: $condition) {
    html
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEventMutationVariables,
  APITypes.UpdateEventMutation
>;
export const deleteEvent = /* GraphQL */ `mutation DeleteEvent(
  $input: DeleteEventInput!
  $condition: ModelEventConditionInput
) {
  deleteEvent(input: $input, condition: $condition) {
    html
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEventMutationVariables,
  APITypes.DeleteEventMutation
>;
export const createLink = /* GraphQL */ `mutation CreateLink(
  $input: CreateLinkInput!
  $condition: ModelLinkConditionInput
) {
  createLink(input: $input, condition: $condition) {
    id
    menuDescriptions {
      nextToken
      __typename
    }
    url
    tenant
    landscape
    sort
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLinkMutationVariables,
  APITypes.CreateLinkMutation
>;
export const updateLink = /* GraphQL */ `mutation UpdateLink(
  $input: UpdateLinkInput!
  $condition: ModelLinkConditionInput
) {
  updateLink(input: $input, condition: $condition) {
    id
    menuDescriptions {
      nextToken
      __typename
    }
    url
    tenant
    landscape
    sort
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLinkMutationVariables,
  APITypes.UpdateLinkMutation
>;
export const deleteLink = /* GraphQL */ `mutation DeleteLink(
  $input: DeleteLinkInput!
  $condition: ModelLinkConditionInput
) {
  deleteLink(input: $input, condition: $condition) {
    id
    menuDescriptions {
      nextToken
      __typename
    }
    url
    tenant
    landscape
    sort
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLinkMutationVariables,
  APITypes.DeleteLinkMutation
>;
export const createMenu = /* GraphQL */ `mutation CreateMenu(
  $input: CreateMenuInput!
  $condition: ModelMenuConditionInput
) {
  createMenu(input: $input, condition: $condition) {
    menuId
    parentMenuId
    menuNames {
      nextToken
      __typename
    }
    menuDescriptions {
      nextToken
      __typename
    }
    url
    isCategory
    product
    schemaId
    loginName
    tenant
    landscape
    tenantLandscapeLoginName
    accessedTimeStamp
    sort
    canUseFromExtra
    menuIconFont
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMenuMutationVariables,
  APITypes.CreateMenuMutation
>;
export const updateMenu = /* GraphQL */ `mutation UpdateMenu(
  $input: UpdateMenuInput!
  $condition: ModelMenuConditionInput
) {
  updateMenu(input: $input, condition: $condition) {
    menuId
    parentMenuId
    menuNames {
      nextToken
      __typename
    }
    menuDescriptions {
      nextToken
      __typename
    }
    url
    isCategory
    product
    schemaId
    loginName
    tenant
    landscape
    tenantLandscapeLoginName
    accessedTimeStamp
    sort
    canUseFromExtra
    menuIconFont
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMenuMutationVariables,
  APITypes.UpdateMenuMutation
>;
export const deleteMenu = /* GraphQL */ `mutation DeleteMenu(
  $input: DeleteMenuInput!
  $condition: ModelMenuConditionInput
) {
  deleteMenu(input: $input, condition: $condition) {
    menuId
    parentMenuId
    menuNames {
      nextToken
      __typename
    }
    menuDescriptions {
      nextToken
      __typename
    }
    url
    isCategory
    product
    schemaId
    loginName
    tenant
    landscape
    tenantLandscapeLoginName
    accessedTimeStamp
    sort
    canUseFromExtra
    menuIconFont
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMenuMutationVariables,
  APITypes.DeleteMenuMutation
>;
export const createMenuDescription = /* GraphQL */ `mutation CreateMenuDescription(
  $input: CreateMenuDescriptionInput!
  $condition: ModelMenuDescriptionConditionInput
) {
  createMenuDescription(input: $input, condition: $condition) {
    language
    description
    menuId
    schemaId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMenuDescriptionMutationVariables,
  APITypes.CreateMenuDescriptionMutation
>;
export const updateMenuDescription = /* GraphQL */ `mutation UpdateMenuDescription(
  $input: UpdateMenuDescriptionInput!
  $condition: ModelMenuDescriptionConditionInput
) {
  updateMenuDescription(input: $input, condition: $condition) {
    language
    description
    menuId
    schemaId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMenuDescriptionMutationVariables,
  APITypes.UpdateMenuDescriptionMutation
>;
export const deleteMenuDescription = /* GraphQL */ `mutation DeleteMenuDescription(
  $input: DeleteMenuDescriptionInput!
  $condition: ModelMenuDescriptionConditionInput
) {
  deleteMenuDescription(input: $input, condition: $condition) {
    language
    description
    menuId
    schemaId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMenuDescriptionMutationVariables,
  APITypes.DeleteMenuDescriptionMutation
>;
export const createLinkMenuDescription = /* GraphQL */ `mutation CreateLinkMenuDescription(
  $input: CreateLinkMenuDescriptionInput!
  $condition: ModelLinkMenuDescriptionConditionInput
) {
  createLinkMenuDescription(input: $input, condition: $condition) {
    language
    description
    menuId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLinkMenuDescriptionMutationVariables,
  APITypes.CreateLinkMenuDescriptionMutation
>;
export const updateLinkMenuDescription = /* GraphQL */ `mutation UpdateLinkMenuDescription(
  $input: UpdateLinkMenuDescriptionInput!
  $condition: ModelLinkMenuDescriptionConditionInput
) {
  updateLinkMenuDescription(input: $input, condition: $condition) {
    language
    description
    menuId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLinkMenuDescriptionMutationVariables,
  APITypes.UpdateLinkMenuDescriptionMutation
>;
export const deleteLinkMenuDescription = /* GraphQL */ `mutation DeleteLinkMenuDescription(
  $input: DeleteLinkMenuDescriptionInput!
  $condition: ModelLinkMenuDescriptionConditionInput
) {
  deleteLinkMenuDescription(input: $input, condition: $condition) {
    language
    description
    menuId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLinkMenuDescriptionMutationVariables,
  APITypes.DeleteLinkMenuDescriptionMutation
>;
export const createMenuName = /* GraphQL */ `mutation CreateMenuName(
  $input: CreateMenuNameInput!
  $condition: ModelMenuNameConditionInput
) {
  createMenuName(input: $input, condition: $condition) {
    language
    name
    menuId
    schemaId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMenuNameMutationVariables,
  APITypes.CreateMenuNameMutation
>;
export const updateMenuName = /* GraphQL */ `mutation UpdateMenuName(
  $input: UpdateMenuNameInput!
  $condition: ModelMenuNameConditionInput
) {
  updateMenuName(input: $input, condition: $condition) {
    language
    name
    menuId
    schemaId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMenuNameMutationVariables,
  APITypes.UpdateMenuNameMutation
>;
export const deleteMenuName = /* GraphQL */ `mutation DeleteMenuName(
  $input: DeleteMenuNameInput!
  $condition: ModelMenuNameConditionInput
) {
  deleteMenuName(input: $input, condition: $condition) {
    language
    name
    menuId
    schemaId
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMenuNameMutationVariables,
  APITypes.DeleteMenuNameMutation
>;
export const createProductMenuName = /* GraphQL */ `mutation CreateProductMenuName(
  $input: CreateProductMenuNameInput!
  $condition: ModelProductMenuNameConditionInput
) {
  createProductMenuName(input: $input, condition: $condition) {
    language
    name
    menuId
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductMenuNameMutationVariables,
  APITypes.CreateProductMenuNameMutation
>;
export const updateProductMenuName = /* GraphQL */ `mutation UpdateProductMenuName(
  $input: UpdateProductMenuNameInput!
  $condition: ModelProductMenuNameConditionInput
) {
  updateProductMenuName(input: $input, condition: $condition) {
    language
    name
    menuId
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductMenuNameMutationVariables,
  APITypes.UpdateProductMenuNameMutation
>;
export const deleteProductMenuName = /* GraphQL */ `mutation DeleteProductMenuName(
  $input: DeleteProductMenuNameInput!
  $condition: ModelProductMenuNameConditionInput
) {
  deleteProductMenuName(input: $input, condition: $condition) {
    language
    name
    menuId
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductMenuNameMutationVariables,
  APITypes.DeleteProductMenuNameMutation
>;
export const createNotice = /* GraphQL */ `mutation CreateNotice(
  $input: CreateNoticeInput!
  $condition: ModelNoticeConditionInput
) {
  createNotice(input: $input, condition: $condition) {
    html
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNoticeMutationVariables,
  APITypes.CreateNoticeMutation
>;
export const updateNotice = /* GraphQL */ `mutation UpdateNotice(
  $input: UpdateNoticeInput!
  $condition: ModelNoticeConditionInput
) {
  updateNotice(input: $input, condition: $condition) {
    html
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNoticeMutationVariables,
  APITypes.UpdateNoticeMutation
>;
export const deleteNotice = /* GraphQL */ `mutation DeleteNotice(
  $input: DeleteNoticeInput!
  $condition: ModelNoticeConditionInput
) {
  deleteNotice(input: $input, condition: $condition) {
    html
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNoticeMutationVariables,
  APITypes.DeleteNoticeMutation
>;
export const createFlag = /* GraphQL */ `mutation CreateFlag(
  $input: CreateFlagInput!
  $condition: ModelFlagConditionInput
) {
  createFlag(input: $input, condition: $condition) {
    flag
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFlagMutationVariables,
  APITypes.CreateFlagMutation
>;
export const updateFlag = /* GraphQL */ `mutation UpdateFlag(
  $input: UpdateFlagInput!
  $condition: ModelFlagConditionInput
) {
  updateFlag(input: $input, condition: $condition) {
    flag
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFlagMutationVariables,
  APITypes.UpdateFlagMutation
>;
export const deleteFlag = /* GraphQL */ `mutation DeleteFlag(
  $input: DeleteFlagInput!
  $condition: ModelFlagConditionInput
) {
  deleteFlag(input: $input, condition: $condition) {
    flag
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFlagMutationVariables,
  APITypes.DeleteFlagMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    displaysFavoritePanel
    isAdmin
    language
    name
    affiliation
    csrSchema
    cwsSchema
    cjkSchema
    ctmSchema
    event {
      html
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    notice {
      html
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    menus {
      nextToken
      __typename
    }
    productMenus {
      nextToken
      __typename
    }
    flags {
      nextToken
      __typename
    }
    favorites {
      nextToken
      __typename
    }
    notifications {
      nextToken
      __typename
    }
    announcements {
      nextToken
      __typename
    }
    scheduledEventMetadatasByCreatedBy {
      nextToken
      __typename
    }
    scheduledEventMetadatasByUpdatedBy {
      nextToken
      __typename
    }
    scheduledEventHistoriesByExecutedBy {
      nextToken
      __typename
    }
    scheduledHolidayMetadatasByCreatedBy {
      nextToken
      __typename
    }
    scheduledHolidayMetadatasByUpdatedBy {
      nextToken
      __typename
    }
    productMenuNames {
      nextToken
      __typename
    }
    countTables {
      nextToken
      __typename
    }
    roleId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    displaysFavoritePanel
    isAdmin
    language
    name
    affiliation
    csrSchema
    cwsSchema
    cjkSchema
    ctmSchema
    event {
      html
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    notice {
      html
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    menus {
      nextToken
      __typename
    }
    productMenus {
      nextToken
      __typename
    }
    flags {
      nextToken
      __typename
    }
    favorites {
      nextToken
      __typename
    }
    notifications {
      nextToken
      __typename
    }
    announcements {
      nextToken
      __typename
    }
    scheduledEventMetadatasByCreatedBy {
      nextToken
      __typename
    }
    scheduledEventMetadatasByUpdatedBy {
      nextToken
      __typename
    }
    scheduledEventHistoriesByExecutedBy {
      nextToken
      __typename
    }
    scheduledHolidayMetadatasByCreatedBy {
      nextToken
      __typename
    }
    scheduledHolidayMetadatasByUpdatedBy {
      nextToken
      __typename
    }
    productMenuNames {
      nextToken
      __typename
    }
    countTables {
      nextToken
      __typename
    }
    roleId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    displaysFavoritePanel
    isAdmin
    language
    name
    affiliation
    csrSchema
    cwsSchema
    cjkSchema
    ctmSchema
    event {
      html
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    notice {
      html
      loginName
      tenant
      landscape
      createdAt
      updatedAt
      __typename
    }
    menus {
      nextToken
      __typename
    }
    productMenus {
      nextToken
      __typename
    }
    flags {
      nextToken
      __typename
    }
    favorites {
      nextToken
      __typename
    }
    notifications {
      nextToken
      __typename
    }
    announcements {
      nextToken
      __typename
    }
    scheduledEventMetadatasByCreatedBy {
      nextToken
      __typename
    }
    scheduledEventMetadatasByUpdatedBy {
      nextToken
      __typename
    }
    scheduledEventHistoriesByExecutedBy {
      nextToken
      __typename
    }
    scheduledHolidayMetadatasByCreatedBy {
      nextToken
      __typename
    }
    scheduledHolidayMetadatasByUpdatedBy {
      nextToken
      __typename
    }
    productMenuNames {
      nextToken
      __typename
    }
    countTables {
      nextToken
      __typename
    }
    roleId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createNotificationOnLoginName = /* GraphQL */ `mutation CreateNotificationOnLoginName(
  $input: CreateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  createNotificationOnLoginName(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    tenantLandscapeLoginName
    product
    notificationId
    content
    iconType
    onClickAction
    extraActions {
      actionName
      onClickAction
      __typename
    }
    displayStartDate
    displayEndDate
    isRead
    isFinished
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotificationOnLoginNameMutationVariables,
  APITypes.CreateNotificationOnLoginNameMutation
>;
export const updateNotification = /* GraphQL */ `mutation UpdateNotification(
  $input: UpdateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  updateNotification(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    tenantLandscapeLoginName
    product
    notificationId
    content
    iconType
    onClickAction
    extraActions {
      actionName
      onClickAction
      __typename
    }
    displayStartDate
    displayEndDate
    isRead
    isFinished
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNotificationMutationVariables,
  APITypes.UpdateNotificationMutation
>;
export const createCountTable = /* GraphQL */ `mutation CreateCountTable(
  $input: CreateCountTableInput!
  $condition: ModelCountTableConditionInput
) {
  createCountTable(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    tableName
    totalCount
    isUnRead
    isExpired
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCountTableMutationVariables,
  APITypes.CreateCountTableMutation
>;
export const updateCountTable = /* GraphQL */ `mutation UpdateCountTable(
  $input: UpdateCountTableInput!
  $condition: ModelCountTableConditionInput
) {
  updateCountTable(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    tableName
    totalCount
    isUnRead
    isExpired
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCountTableMutationVariables,
  APITypes.UpdateCountTableMutation
>;
export const deleteCountTable = /* GraphQL */ `mutation DeleteCountTable(
  $input: DeleteCountTableInput!
  $condition: ModelCountTableConditionInput
) {
  deleteCountTable(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    tableName
    totalCount
    isUnRead
    isExpired
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCountTableMutationVariables,
  APITypes.DeleteCountTableMutation
>;
export const createAnnouncement = /* GraphQL */ `mutation CreateAnnouncement(
  $input: CreateAnnouncementInput!
  $condition: ModelAnnouncementConditionInput
) {
  createAnnouncement(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    users {
      nextToken
      __typename
    }
    title
    content
    linkToProductMenu
    isPublic
    displayStartDate
    displayEndDate
    priorityTag
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAnnouncementMutationVariables,
  APITypes.CreateAnnouncementMutation
>;
export const updateAnnouncement = /* GraphQL */ `mutation UpdateAnnouncement(
  $input: UpdateAnnouncementInput!
  $condition: ModelAnnouncementConditionInput
) {
  updateAnnouncement(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    users {
      nextToken
      __typename
    }
    title
    content
    linkToProductMenu
    isPublic
    displayStartDate
    displayEndDate
    priorityTag
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAnnouncementMutationVariables,
  APITypes.UpdateAnnouncementMutation
>;
export const deleteAnnouncement = /* GraphQL */ `mutation DeleteAnnouncement(
  $input: DeleteAnnouncementInput!
  $condition: ModelAnnouncementConditionInput
) {
  deleteAnnouncement(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    users {
      nextToken
      __typename
    }
    title
    content
    linkToProductMenu
    isPublic
    displayStartDate
    displayEndDate
    priorityTag
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAnnouncementMutationVariables,
  APITypes.DeleteAnnouncementMutation
>;
export const createUserAnnouncement = /* GraphQL */ `mutation CreateUserAnnouncement(
  $input: CreateUserAnnouncementInput!
  $condition: ModelUserAnnouncementConditionInput
) {
  createUserAnnouncement(input: $input, condition: $condition) {
    announcementId
    loginName
    tenant
    landscape
    tenantLandscapeLoginName
    announcement {
      id
      tenant
      landscape
      tenantLandscape
      title
      content
      linkToProductMenu
      isPublic
      displayStartDate
      displayEndDate
      priorityTag
      createdAt
      updatedAt
      __typename
    }
    displayStartDate
    displayEndDate
    isProcessed
    isRead
    isShow
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserAnnouncementMutationVariables,
  APITypes.CreateUserAnnouncementMutation
>;
export const updateUserAnnouncement = /* GraphQL */ `mutation UpdateUserAnnouncement(
  $input: UpdateUserAnnouncementInput!
  $condition: ModelUserAnnouncementConditionInput
) {
  updateUserAnnouncement(input: $input, condition: $condition) {
    announcementId
    loginName
    tenant
    landscape
    tenantLandscapeLoginName
    announcement {
      id
      tenant
      landscape
      tenantLandscape
      title
      content
      linkToProductMenu
      isPublic
      displayStartDate
      displayEndDate
      priorityTag
      createdAt
      updatedAt
      __typename
    }
    displayStartDate
    displayEndDate
    isProcessed
    isRead
    isShow
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserAnnouncementMutationVariables,
  APITypes.UpdateUserAnnouncementMutation
>;
export const deleteUserAnnouncement = /* GraphQL */ `mutation DeleteUserAnnouncement(
  $input: DeleteUserAnnouncementInput!
  $condition: ModelUserAnnouncementConditionInput
) {
  deleteUserAnnouncement(input: $input, condition: $condition) {
    announcementId
    loginName
    tenant
    landscape
    tenantLandscapeLoginName
    announcement {
      id
      tenant
      landscape
      tenantLandscape
      title
      content
      linkToProductMenu
      isPublic
      displayStartDate
      displayEndDate
      priorityTag
      createdAt
      updatedAt
      __typename
    }
    displayStartDate
    displayEndDate
    isProcessed
    isRead
    isShow
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserAnnouncementMutationVariables,
  APITypes.DeleteUserAnnouncementMutation
>;
export const createFavorite = /* GraphQL */ `mutation CreateFavorite(
  $input: CreateFavoriteInput!
  $condition: ModelFavoriteConditionInput
) {
  createFavorite(input: $input, condition: $condition) {
    sort
    menuId
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFavoriteMutationVariables,
  APITypes.CreateFavoriteMutation
>;
export const updateFavorite = /* GraphQL */ `mutation UpdateFavorite(
  $input: UpdateFavoriteInput!
  $condition: ModelFavoriteConditionInput
) {
  updateFavorite(input: $input, condition: $condition) {
    sort
    menuId
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFavoriteMutationVariables,
  APITypes.UpdateFavoriteMutation
>;
export const deleteFavorite = /* GraphQL */ `mutation DeleteFavorite(
  $input: DeleteFavoriteInput!
  $condition: ModelFavoriteConditionInput
) {
  deleteFavorite(input: $input, condition: $condition) {
    sort
    menuId
    loginName
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFavoriteMutationVariables,
  APITypes.DeleteFavoriteMutation
>;
export const createMenuIndex = /* GraphQL */ `mutation CreateMenuIndex(
  $input: CreateMenuIndexInput!
  $condition: ModelMenuIndexConditionInput
) {
  createMenuIndex(input: $input, condition: $condition) {
    index
    menuId
    product
    schema
    language
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMenuIndexMutationVariables,
  APITypes.CreateMenuIndexMutation
>;
export const updateMenuIndex = /* GraphQL */ `mutation UpdateMenuIndex(
  $input: UpdateMenuIndexInput!
  $condition: ModelMenuIndexConditionInput
) {
  updateMenuIndex(input: $input, condition: $condition) {
    index
    menuId
    product
    schema
    language
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMenuIndexMutationVariables,
  APITypes.UpdateMenuIndexMutation
>;
export const deleteMenuIndex = /* GraphQL */ `mutation DeleteMenuIndex(
  $input: DeleteMenuIndexInput!
  $condition: ModelMenuIndexConditionInput
) {
  deleteMenuIndex(input: $input, condition: $condition) {
    index
    menuId
    product
    schema
    language
    tenant
    landscape
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMenuIndexMutationVariables,
  APITypes.DeleteMenuIndexMutation
>;
export const createProductMenu = /* GraphQL */ `mutation CreateProductMenu(
  $input: CreateProductMenuInput!
  $condition: ModelProductMenuConditionInput
) {
  createProductMenu(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    menuId
    menuNames {
      nextToken
      __typename
    }
    isHome
    stateKey
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProductMenuMutationVariables,
  APITypes.CreateProductMenuMutation
>;
export const updateProductMenu = /* GraphQL */ `mutation UpdateProductMenu(
  $input: UpdateProductMenuInput!
  $condition: ModelProductMenuConditionInput
) {
  updateProductMenu(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    menuId
    menuNames {
      nextToken
      __typename
    }
    isHome
    stateKey
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductMenuMutationVariables,
  APITypes.UpdateProductMenuMutation
>;
export const deleteProductMenu = /* GraphQL */ `mutation DeleteProductMenu(
  $input: DeleteProductMenuInput!
  $condition: ModelProductMenuConditionInput
) {
  deleteProductMenu(input: $input, condition: $condition) {
    loginName
    tenant
    landscape
    menuId
    menuNames {
      nextToken
      __typename
    }
    isHome
    stateKey
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProductMenuMutationVariables,
  APITypes.DeleteProductMenuMutation
>;
export const createGatewayServer = /* GraphQL */ `mutation CreateGatewayServer(
  $input: CreateGatewayServerInput!
  $condition: ModelGatewayServerConditionInput
) {
  createGatewayServer(input: $input, condition: $condition) {
    tenant
    landscape
    product
    useInternetAccess
    isInternalGateWayServer
    gatewayServerIps
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGatewayServerMutationVariables,
  APITypes.CreateGatewayServerMutation
>;
export const updateGatewayServer = /* GraphQL */ `mutation UpdateGatewayServer(
  $input: UpdateGatewayServerInput!
  $condition: ModelGatewayServerConditionInput
) {
  updateGatewayServer(input: $input, condition: $condition) {
    tenant
    landscape
    product
    useInternetAccess
    isInternalGateWayServer
    gatewayServerIps
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGatewayServerMutationVariables,
  APITypes.UpdateGatewayServerMutation
>;
export const deleteGatewayServer = /* GraphQL */ `mutation DeleteGatewayServer(
  $input: DeleteGatewayServerInput!
  $condition: ModelGatewayServerConditionInput
) {
  deleteGatewayServer(input: $input, condition: $condition) {
    tenant
    landscape
    product
    useInternetAccess
    isInternalGateWayServer
    gatewayServerIps
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteGatewayServerMutationVariables,
  APITypes.DeleteGatewayServerMutation
>;
export const createCognitoInfo = /* GraphQL */ `mutation CreateCognitoInfo(
  $input: CreateCognitoInfoInput!
  $condition: ModelCognitoInfoConditionInput
) {
  createCognitoInfo(input: $input, condition: $condition) {
    tenant
    landscape
    identityPoolId
    region
    userPoolId
    userPoolWebClientId
    identityProvider
    amazonCognitoDomain
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCognitoInfoMutationVariables,
  APITypes.CreateCognitoInfoMutation
>;
export const updateCognitoInfo = /* GraphQL */ `mutation UpdateCognitoInfo(
  $input: UpdateCognitoInfoInput!
  $condition: ModelCognitoInfoConditionInput
) {
  updateCognitoInfo(input: $input, condition: $condition) {
    tenant
    landscape
    identityPoolId
    region
    userPoolId
    userPoolWebClientId
    identityProvider
    amazonCognitoDomain
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCognitoInfoMutationVariables,
  APITypes.UpdateCognitoInfoMutation
>;
export const deleteCognitoInfo = /* GraphQL */ `mutation DeleteCognitoInfo(
  $input: DeleteCognitoInfoInput!
  $condition: ModelCognitoInfoConditionInput
) {
  deleteCognitoInfo(input: $input, condition: $condition) {
    tenant
    landscape
    identityPoolId
    region
    userPoolId
    userPoolWebClientId
    identityProvider
    amazonCognitoDomain
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCognitoInfoMutationVariables,
  APITypes.DeleteCognitoInfoMutation
>;
export const createAPIGatewayInfo = /* GraphQL */ `mutation CreateAPIGatewayInfo(
  $input: CreateAPIGatewayInfoInput!
  $condition: ModelAPIGatewayInfoConditionInput
) {
  createAPIGatewayInfo(input: $input, condition: $condition) {
    tenant
    landscape
    endpoint
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAPIGatewayInfoMutationVariables,
  APITypes.CreateAPIGatewayInfoMutation
>;
export const updateAPIGatewayInfo = /* GraphQL */ `mutation UpdateAPIGatewayInfo(
  $input: UpdateAPIGatewayInfoInput!
  $condition: ModelAPIGatewayInfoConditionInput
) {
  updateAPIGatewayInfo(input: $input, condition: $condition) {
    tenant
    landscape
    endpoint
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAPIGatewayInfoMutationVariables,
  APITypes.UpdateAPIGatewayInfoMutation
>;
export const deleteAPIGatewayInfo = /* GraphQL */ `mutation DeleteAPIGatewayInfo(
  $input: DeleteAPIGatewayInfoInput!
  $condition: ModelAPIGatewayInfoConditionInput
) {
  deleteAPIGatewayInfo(input: $input, condition: $condition) {
    tenant
    landscape
    endpoint
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAPIGatewayInfoMutationVariables,
  APITypes.DeleteAPIGatewayInfoMutation
>;
export const createBackendInfo = /* GraphQL */ `mutation CreateBackendInfo(
  $input: CreateBackendInfoInput!
  $condition: ModelBackendInfoConditionInput
) {
  createBackendInfo(input: $input, condition: $condition) {
    tenant
    landscape
    apiGatewayInfo {
      tenant
      landscape
      endpoint
      createdAt
      updatedAt
      __typename
    }
    cognitoInfo {
      tenant
      landscape
      identityPoolId
      region
      userPoolId
      userPoolWebClientId
      identityProvider
      amazonCognitoDomain
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBackendInfoMutationVariables,
  APITypes.CreateBackendInfoMutation
>;
export const updateBackendInfo = /* GraphQL */ `mutation UpdateBackendInfo(
  $input: UpdateBackendInfoInput!
  $condition: ModelBackendInfoConditionInput
) {
  updateBackendInfo(input: $input, condition: $condition) {
    tenant
    landscape
    apiGatewayInfo {
      tenant
      landscape
      endpoint
      createdAt
      updatedAt
      __typename
    }
    cognitoInfo {
      tenant
      landscape
      identityPoolId
      region
      userPoolId
      userPoolWebClientId
      identityProvider
      amazonCognitoDomain
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBackendInfoMutationVariables,
  APITypes.UpdateBackendInfoMutation
>;
export const deleteBackendInfo = /* GraphQL */ `mutation DeleteBackendInfo(
  $input: DeleteBackendInfoInput!
  $condition: ModelBackendInfoConditionInput
) {
  deleteBackendInfo(input: $input, condition: $condition) {
    tenant
    landscape
    apiGatewayInfo {
      tenant
      landscape
      endpoint
      createdAt
      updatedAt
      __typename
    }
    cognitoInfo {
      tenant
      landscape
      identityPoolId
      region
      userPoolId
      userPoolWebClientId
      identityProvider
      amazonCognitoDomain
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBackendInfoMutationVariables,
  APITypes.DeleteBackendInfoMutation
>;
export const createAuthQuery = /* GraphQL */ `mutation CreateAuthQuery(
  $input: CreateAuthQueryInput!
  $condition: ModelAuthQueryConditionInput
) {
  createAuthQuery(input: $input, condition: $condition) {
    tenant
    landscape
    identityProvider
    product
    additionalQuery
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAuthQueryMutationVariables,
  APITypes.CreateAuthQueryMutation
>;
export const updateAuthQuery = /* GraphQL */ `mutation UpdateAuthQuery(
  $input: UpdateAuthQueryInput!
  $condition: ModelAuthQueryConditionInput
) {
  updateAuthQuery(input: $input, condition: $condition) {
    tenant
    landscape
    identityProvider
    product
    additionalQuery
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAuthQueryMutationVariables,
  APITypes.UpdateAuthQueryMutation
>;
export const deleteAuthQuery = /* GraphQL */ `mutation DeleteAuthQuery(
  $input: DeleteAuthQueryInput!
  $condition: ModelAuthQueryConditionInput
) {
  deleteAuthQuery(input: $input, condition: $condition) {
    tenant
    landscape
    identityProvider
    product
    additionalQuery
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAuthQueryMutationVariables,
  APITypes.DeleteAuthQueryMutation
>;
export const createSystemSettingInfo = /* GraphQL */ `mutation CreateSystemSettingInfo(
  $input: CreateSystemSettingInfoInput!
  $condition: ModelSystemSettingInfoConditionInput
) {
  createSystemSettingInfo(input: $input, condition: $condition) {
    tenant
    landscape
    isMultilanguageEnabled
    isNotificationEnabled
    isJobSchedulerEnabled
    isPortalEnabled
    announcementSetting
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSystemSettingInfoMutationVariables,
  APITypes.CreateSystemSettingInfoMutation
>;
export const updateSystemSettingInfo = /* GraphQL */ `mutation UpdateSystemSettingInfo(
  $input: UpdateSystemSettingInfoInput!
  $condition: ModelSystemSettingInfoConditionInput
) {
  updateSystemSettingInfo(input: $input, condition: $condition) {
    tenant
    landscape
    isMultilanguageEnabled
    isNotificationEnabled
    isJobSchedulerEnabled
    isPortalEnabled
    announcementSetting
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSystemSettingInfoMutationVariables,
  APITypes.UpdateSystemSettingInfoMutation
>;
export const deleteSystemSettingInfo = /* GraphQL */ `mutation DeleteSystemSettingInfo(
  $input: DeleteSystemSettingInfoInput!
  $condition: ModelSystemSettingInfoConditionInput
) {
  deleteSystemSettingInfo(input: $input, condition: $condition) {
    tenant
    landscape
    isMultilanguageEnabled
    isNotificationEnabled
    isJobSchedulerEnabled
    isPortalEnabled
    announcementSetting
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSystemSettingInfoMutationVariables,
  APITypes.DeleteSystemSettingInfoMutation
>;
export const createCustomerCompanyVersion = /* GraphQL */ `mutation CreateCustomerCompanyVersion(
  $input: CreateCustomerCompanyVersionInput!
  $condition: ModelCustomerCompanyVersionConditionInput
) {
  createCustomerCompanyVersion(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    version
    product
    applyDateTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCustomerCompanyVersionMutationVariables,
  APITypes.CreateCustomerCompanyVersionMutation
>;
export const updateCustomerCompanyVersion = /* GraphQL */ `mutation UpdateCustomerCompanyVersion(
  $input: UpdateCustomerCompanyVersionInput!
  $condition: ModelCustomerCompanyVersionConditionInput
) {
  updateCustomerCompanyVersion(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    version
    product
    applyDateTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCustomerCompanyVersionMutationVariables,
  APITypes.UpdateCustomerCompanyVersionMutation
>;
export const deleteCustomerCompanyVersion = /* GraphQL */ `mutation DeleteCustomerCompanyVersion(
  $input: DeleteCustomerCompanyVersionInput!
  $condition: ModelCustomerCompanyVersionConditionInput
) {
  deleteCustomerCompanyVersion(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    version
    product
    applyDateTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCustomerCompanyVersionMutationVariables,
  APITypes.DeleteCustomerCompanyVersionMutation
>;
export const createTaskMetadata = /* GraphQL */ `mutation CreateTaskMetadata(
  $input: CreateTaskMetadataInput!
  $condition: ModelTaskMetadataConditionInput
) {
  createTaskMetadata(input: $input, condition: $condition) {
    version
    product
    batch
    batchName
    versionProductBatch
    args {
      required
      default
      display
      order
      option
      type
      delimiter
      isMultiple
      isOutputFile
      isInputFile
      isSecret
      sampleInput
      isResolvable
      __typename
    }
    requestBodyPropertyTemplates {
      requestBodyProperty
      template
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaskMetadataMutationVariables,
  APITypes.CreateTaskMetadataMutation
>;
export const updateTaskMetadata = /* GraphQL */ `mutation UpdateTaskMetadata(
  $input: UpdateTaskMetadataInput!
  $condition: ModelTaskMetadataConditionInput
) {
  updateTaskMetadata(input: $input, condition: $condition) {
    version
    product
    batch
    batchName
    versionProductBatch
    args {
      required
      default
      display
      order
      option
      type
      delimiter
      isMultiple
      isOutputFile
      isInputFile
      isSecret
      sampleInput
      isResolvable
      __typename
    }
    requestBodyPropertyTemplates {
      requestBodyProperty
      template
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaskMetadataMutationVariables,
  APITypes.UpdateTaskMetadataMutation
>;
export const deleteTaskMetadata = /* GraphQL */ `mutation DeleteTaskMetadata(
  $input: DeleteTaskMetadataInput!
  $condition: ModelTaskMetadataConditionInput
) {
  deleteTaskMetadata(input: $input, condition: $condition) {
    version
    product
    batch
    batchName
    versionProductBatch
    args {
      required
      default
      display
      order
      option
      type
      delimiter
      isMultiple
      isOutputFile
      isInputFile
      isSecret
      sampleInput
      isResolvable
      __typename
    }
    requestBodyPropertyTemplates {
      requestBodyProperty
      template
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaskMetadataMutationVariables,
  APITypes.DeleteTaskMetadataMutation
>;
export const createTenantUsingMoveFileTask = /* GraphQL */ `mutation CreateTenantUsingMoveFileTask(
  $input: CreateTenantUsingMoveFileTaskInput!
  $condition: ModelTenantUsingMoveFileTaskConditionInput
) {
  createTenantUsingMoveFileTask(input: $input, condition: $condition) {
    tenant
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTenantUsingMoveFileTaskMutationVariables,
  APITypes.CreateTenantUsingMoveFileTaskMutation
>;
export const updateTenantUsingMoveFileTask = /* GraphQL */ `mutation UpdateTenantUsingMoveFileTask(
  $input: UpdateTenantUsingMoveFileTaskInput!
  $condition: ModelTenantUsingMoveFileTaskConditionInput
) {
  updateTenantUsingMoveFileTask(input: $input, condition: $condition) {
    tenant
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTenantUsingMoveFileTaskMutationVariables,
  APITypes.UpdateTenantUsingMoveFileTaskMutation
>;
export const deleteTenantUsingMoveFileTask = /* GraphQL */ `mutation DeleteTenantUsingMoveFileTask(
  $input: DeleteTenantUsingMoveFileTaskInput!
  $condition: ModelTenantUsingMoveFileTaskConditionInput
) {
  deleteTenantUsingMoveFileTask(input: $input, condition: $condition) {
    tenant
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTenantUsingMoveFileTaskMutationVariables,
  APITypes.DeleteTenantUsingMoveFileTaskMutation
>;
export const createJob = /* GraphQL */ `mutation CreateJob(
  $input: CreateJobInput!
  $condition: ModelJobConditionInput
) {
  createJob(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    jobCode
    title
    description
    jobTriggerFilePath
    tasks {
      nextToken
      __typename
    }
    hasOutputFile
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateJobMutationVariables,
  APITypes.CreateJobMutation
>;
export const updateJob = /* GraphQL */ `mutation UpdateJob(
  $input: UpdateJobInput!
  $condition: ModelJobConditionInput
) {
  updateJob(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    jobCode
    title
    description
    jobTriggerFilePath
    tasks {
      nextToken
      __typename
    }
    hasOutputFile
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateJobMutationVariables,
  APITypes.UpdateJobMutation
>;
export const deleteJob = /* GraphQL */ `mutation DeleteJob(
  $input: DeleteJobInput!
  $condition: ModelJobConditionInput
) {
  deleteJob(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    jobCode
    title
    description
    jobTriggerFilePath
    tasks {
      nextToken
      __typename
    }
    hasOutputFile
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteJobMutationVariables,
  APITypes.DeleteJobMutation
>;
export const createTask = /* GraphQL */ `mutation CreateTask(
  $input: CreateTaskInput!
  $condition: ModelTaskConditionInput
) {
  createTask(input: $input, condition: $condition) {
    version
    product
    batch
    batchName
    versionProductBatch
    jobId
    order
    jobIdOrder
    taskMetadata {
      version
      product
      batch
      batchName
      versionProductBatch
      createdAt
      updatedAt
      __typename
    }
    title
    args {
      order
      option
      value
      replaceInFileName
      __typename
    }
    includeInDownload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaskMutationVariables,
  APITypes.CreateTaskMutation
>;
export const updateTask = /* GraphQL */ `mutation UpdateTask(
  $input: UpdateTaskInput!
  $condition: ModelTaskConditionInput
) {
  updateTask(input: $input, condition: $condition) {
    version
    product
    batch
    batchName
    versionProductBatch
    jobId
    order
    jobIdOrder
    taskMetadata {
      version
      product
      batch
      batchName
      versionProductBatch
      createdAt
      updatedAt
      __typename
    }
    title
    args {
      order
      option
      value
      replaceInFileName
      __typename
    }
    includeInDownload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaskMutationVariables,
  APITypes.UpdateTaskMutation
>;
export const deleteTask = /* GraphQL */ `mutation DeleteTask(
  $input: DeleteTaskInput!
  $condition: ModelTaskConditionInput
) {
  deleteTask(input: $input, condition: $condition) {
    version
    product
    batch
    batchName
    versionProductBatch
    jobId
    order
    jobIdOrder
    taskMetadata {
      version
      product
      batch
      batchName
      versionProductBatch
      createdAt
      updatedAt
      __typename
    }
    title
    args {
      order
      option
      value
      replaceInFileName
      __typename
    }
    includeInDownload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaskMutationVariables,
  APITypes.DeleteTaskMutation
>;
export const createScheduledEventMetadata = /* GraphQL */ `mutation CreateScheduledEventMetadata(
  $input: CreateScheduledEventMetadataInput!
  $condition: ModelScheduledEventMetadataConditionInput
) {
  createScheduledEventMetadata(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    jobId
    job {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      hasOutputFile
      createdAt
      updatedAt
      __typename
    }
    repeatType
    rruleSet
    holidayExecutionType
    useCustomHoliday
    customHolidayLabels
    eventTriggerType
    createdBy
    updatedBy
    editedAt
    expirationDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateScheduledEventMetadataMutationVariables,
  APITypes.CreateScheduledEventMetadataMutation
>;
export const updateScheduledEventMetadata = /* GraphQL */ `mutation UpdateScheduledEventMetadata(
  $input: UpdateScheduledEventMetadataInput!
  $condition: ModelScheduledEventMetadataConditionInput
) {
  updateScheduledEventMetadata(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    jobId
    job {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      hasOutputFile
      createdAt
      updatedAt
      __typename
    }
    repeatType
    rruleSet
    holidayExecutionType
    useCustomHoliday
    customHolidayLabels
    eventTriggerType
    createdBy
    updatedBy
    editedAt
    expirationDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateScheduledEventMetadataMutationVariables,
  APITypes.UpdateScheduledEventMetadataMutation
>;
export const deleteScheduledEventMetadata = /* GraphQL */ `mutation DeleteScheduledEventMetadata(
  $input: DeleteScheduledEventMetadataInput!
  $condition: ModelScheduledEventMetadataConditionInput
) {
  deleteScheduledEventMetadata(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    jobId
    job {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      hasOutputFile
      createdAt
      updatedAt
      __typename
    }
    repeatType
    rruleSet
    holidayExecutionType
    useCustomHoliday
    customHolidayLabels
    eventTriggerType
    createdBy
    updatedBy
    editedAt
    expirationDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteScheduledEventMetadataMutationVariables,
  APITypes.DeleteScheduledEventMetadataMutation
>;
export const createScheduledEventHistory = /* GraphQL */ `mutation CreateScheduledEventHistory(
  $input: CreateScheduledEventHistoryInput!
  $condition: ModelScheduledEventHistoryConditionInput
) {
  createScheduledEventHistory(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    scheduledEventMetadataId
    scheduledEventMetadata {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
      __typename
    }
    eventStartDateTime
    jobId
    job {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      hasOutputFile
      createdAt
      updatedAt
      __typename
    }
    jobExecutionStatus
    tasks {
      nextToken
      __typename
    }
    taskHistories {
      nextToken
      __typename
    }
    executedBy
    executionArn
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateScheduledEventHistoryMutationVariables,
  APITypes.CreateScheduledEventHistoryMutation
>;
export const updateScheduledEventHistory = /* GraphQL */ `mutation UpdateScheduledEventHistory(
  $input: UpdateScheduledEventHistoryInput!
  $condition: ModelScheduledEventHistoryConditionInput
) {
  updateScheduledEventHistory(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    scheduledEventMetadataId
    scheduledEventMetadata {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
      __typename
    }
    eventStartDateTime
    jobId
    job {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      hasOutputFile
      createdAt
      updatedAt
      __typename
    }
    jobExecutionStatus
    tasks {
      nextToken
      __typename
    }
    taskHistories {
      nextToken
      __typename
    }
    executedBy
    executionArn
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateScheduledEventHistoryMutationVariables,
  APITypes.UpdateScheduledEventHistoryMutation
>;
export const deleteScheduledEventHistory = /* GraphQL */ `mutation DeleteScheduledEventHistory(
  $input: DeleteScheduledEventHistoryInput!
  $condition: ModelScheduledEventHistoryConditionInput
) {
  deleteScheduledEventHistory(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    scheduledEventMetadataId
    scheduledEventMetadata {
      id
      tenant
      landscape
      tenantLandscape
      title
      description
      jobId
      repeatType
      rruleSet
      holidayExecutionType
      useCustomHoliday
      customHolidayLabels
      eventTriggerType
      createdBy
      updatedBy
      editedAt
      expirationDate
      createdAt
      updatedAt
      __typename
    }
    eventStartDateTime
    jobId
    job {
      id
      tenant
      landscape
      tenantLandscape
      jobCode
      title
      description
      jobTriggerFilePath
      hasOutputFile
      createdAt
      updatedAt
      __typename
    }
    jobExecutionStatus
    tasks {
      nextToken
      __typename
    }
    taskHistories {
      nextToken
      __typename
    }
    executedBy
    executionArn
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteScheduledEventHistoryMutationVariables,
  APITypes.DeleteScheduledEventHistoryMutation
>;
export const createTaskHistory = /* GraphQL */ `mutation CreateTaskHistory(
  $input: CreateTaskHistoryInput!
  $condition: ModelTaskHistoryConditionInput
) {
  createTaskHistory(input: $input, condition: $condition) {
    jobIdOrder
    jobId
    order
    scheduledEventHistoryId
    task {
      version
      product
      batch
      batchName
      versionProductBatch
      jobId
      order
      jobIdOrder
      title
      includeInDownload
      createdAt
      updatedAt
      __typename
    }
    tenant
    landscape
    tenantLandscape
    taskStartDateTime
    taskEndDateTime
    taskExecutionStatus
    log
    outputFilePath
    includeInDownload
    taskTitle
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaskHistoryMutationVariables,
  APITypes.CreateTaskHistoryMutation
>;
export const updateTaskHistory = /* GraphQL */ `mutation UpdateTaskHistory(
  $input: UpdateTaskHistoryInput!
  $condition: ModelTaskHistoryConditionInput
) {
  updateTaskHistory(input: $input, condition: $condition) {
    jobIdOrder
    jobId
    order
    scheduledEventHistoryId
    task {
      version
      product
      batch
      batchName
      versionProductBatch
      jobId
      order
      jobIdOrder
      title
      includeInDownload
      createdAt
      updatedAt
      __typename
    }
    tenant
    landscape
    tenantLandscape
    taskStartDateTime
    taskEndDateTime
    taskExecutionStatus
    log
    outputFilePath
    includeInDownload
    taskTitle
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaskHistoryMutationVariables,
  APITypes.UpdateTaskHistoryMutation
>;
export const deleteTaskHistory = /* GraphQL */ `mutation DeleteTaskHistory(
  $input: DeleteTaskHistoryInput!
  $condition: ModelTaskHistoryConditionInput
) {
  deleteTaskHistory(input: $input, condition: $condition) {
    jobIdOrder
    jobId
    order
    scheduledEventHistoryId
    task {
      version
      product
      batch
      batchName
      versionProductBatch
      jobId
      order
      jobIdOrder
      title
      includeInDownload
      createdAt
      updatedAt
      __typename
    }
    tenant
    landscape
    tenantLandscape
    taskStartDateTime
    taskEndDateTime
    taskExecutionStatus
    log
    outputFilePath
    includeInDownload
    taskTitle
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaskHistoryMutationVariables,
  APITypes.DeleteTaskHistoryMutation
>;
export const createScheduledHolidayMetadata = /* GraphQL */ `mutation CreateScheduledHolidayMetadata(
  $input: CreateScheduledHolidayMetadataInput!
  $condition: ModelScheduledHolidayMetadataConditionInput
) {
  createScheduledHolidayMetadata(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    repeatType
    rruleSet
    labels
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateScheduledHolidayMetadataMutationVariables,
  APITypes.CreateScheduledHolidayMetadataMutation
>;
export const updateScheduledHolidayMetadata = /* GraphQL */ `mutation UpdateScheduledHolidayMetadata(
  $input: UpdateScheduledHolidayMetadataInput!
  $condition: ModelScheduledHolidayMetadataConditionInput
) {
  updateScheduledHolidayMetadata(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    repeatType
    rruleSet
    labels
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateScheduledHolidayMetadataMutationVariables,
  APITypes.UpdateScheduledHolidayMetadataMutation
>;
export const deleteScheduledHolidayMetadata = /* GraphQL */ `mutation DeleteScheduledHolidayMetadata(
  $input: DeleteScheduledHolidayMetadataInput!
  $condition: ModelScheduledHolidayMetadataConditionInput
) {
  deleteScheduledHolidayMetadata(input: $input, condition: $condition) {
    id
    tenant
    landscape
    tenantLandscape
    title
    description
    repeatType
    rruleSet
    labels
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteScheduledHolidayMetadataMutationVariables,
  APITypes.DeleteScheduledHolidayMetadataMutation
>;
export const createPublicHoliday = /* GraphQL */ `mutation CreatePublicHoliday(
  $input: CreatePublicHolidayInput!
  $condition: ModelPublicHolidayConditionInput
) {
  createPublicHoliday(input: $input, condition: $condition) {
    startDate
    language
    title
    label
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePublicHolidayMutationVariables,
  APITypes.CreatePublicHolidayMutation
>;
export const updatePublicHoliday = /* GraphQL */ `mutation UpdatePublicHoliday(
  $input: UpdatePublicHolidayInput!
  $condition: ModelPublicHolidayConditionInput
) {
  updatePublicHoliday(input: $input, condition: $condition) {
    startDate
    language
    title
    label
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePublicHolidayMutationVariables,
  APITypes.UpdatePublicHolidayMutation
>;
export const deletePublicHoliday = /* GraphQL */ `mutation DeletePublicHoliday(
  $input: DeletePublicHolidayInput!
  $condition: ModelPublicHolidayConditionInput
) {
  deletePublicHoliday(input: $input, condition: $condition) {
    startDate
    language
    title
    label
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePublicHolidayMutationVariables,
  APITypes.DeletePublicHolidayMutation
>;
export const createWebsocketConnection = /* GraphQL */ `mutation CreateWebsocketConnection(
  $input: CreateWebsocketConnectionInput!
  $condition: ModelWebsocketConnectionConditionInput
) {
  createWebsocketConnection(input: $input, condition: $condition) {
    connectionId
    endpoint
    tenant
    landscape
    hostname
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWebsocketConnectionMutationVariables,
  APITypes.CreateWebsocketConnectionMutation
>;
export const updateWebsocketConnection = /* GraphQL */ `mutation UpdateWebsocketConnection(
  $input: UpdateWebsocketConnectionInput!
  $condition: ModelWebsocketConnectionConditionInput
) {
  updateWebsocketConnection(input: $input, condition: $condition) {
    connectionId
    endpoint
    tenant
    landscape
    hostname
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWebsocketConnectionMutationVariables,
  APITypes.UpdateWebsocketConnectionMutation
>;
export const deleteWebsocketConnection = /* GraphQL */ `mutation DeleteWebsocketConnection(
  $input: DeleteWebsocketConnectionInput!
  $condition: ModelWebsocketConnectionConditionInput
) {
  deleteWebsocketConnection(input: $input, condition: $condition) {
    connectionId
    endpoint
    tenant
    landscape
    hostname
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWebsocketConnectionMutationVariables,
  APITypes.DeleteWebsocketConnectionMutation
>;
export const createWebsocketWaitingResponse = /* GraphQL */ `mutation CreateWebsocketWaitingResponse(
  $input: CreateWebsocketWaitingResponseInput!
  $condition: ModelWebsocketWaitingResponseConditionInput
) {
  createWebsocketWaitingResponse(input: $input, condition: $condition) {
    parentId
    connectionId
    messageType
    receivedAt
    timeoutAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWebsocketWaitingResponseMutationVariables,
  APITypes.CreateWebsocketWaitingResponseMutation
>;
export const updateWebsocketWaitingResponse = /* GraphQL */ `mutation UpdateWebsocketWaitingResponse(
  $input: UpdateWebsocketWaitingResponseInput!
  $condition: ModelWebsocketWaitingResponseConditionInput
) {
  updateWebsocketWaitingResponse(input: $input, condition: $condition) {
    parentId
    connectionId
    messageType
    receivedAt
    timeoutAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWebsocketWaitingResponseMutationVariables,
  APITypes.UpdateWebsocketWaitingResponseMutation
>;
export const deleteWebsocketWaitingResponse = /* GraphQL */ `mutation DeleteWebsocketWaitingResponse(
  $input: DeleteWebsocketWaitingResponseInput!
  $condition: ModelWebsocketWaitingResponseConditionInput
) {
  deleteWebsocketWaitingResponse(input: $input, condition: $condition) {
    parentId
    connectionId
    messageType
    receivedAt
    timeoutAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWebsocketWaitingResponseMutationVariables,
  APITypes.DeleteWebsocketWaitingResponseMutation
>;
export const createRole = /* GraphQL */ `mutation CreateRole(
  $input: CreateRoleInput!
  $condition: ModelRoleConditionInput
) {
  createRole(input: $input, condition: $condition) {
    id
    name
    description
    isDefault
    systemType
    tenant
    landscape
    permissions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRoleMutationVariables,
  APITypes.CreateRoleMutation
>;
export const updateRole = /* GraphQL */ `mutation UpdateRole(
  $input: UpdateRoleInput!
  $condition: ModelRoleConditionInput
) {
  updateRole(input: $input, condition: $condition) {
    id
    name
    description
    isDefault
    systemType
    tenant
    landscape
    permissions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRoleMutationVariables,
  APITypes.UpdateRoleMutation
>;
export const deleteRole = /* GraphQL */ `mutation DeleteRole(
  $input: DeleteRoleInput!
  $condition: ModelRoleConditionInput
) {
  deleteRole(input: $input, condition: $condition) {
    id
    name
    description
    isDefault
    systemType
    tenant
    landscape
    permissions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRoleMutationVariables,
  APITypes.DeleteRoleMutation
>;
